module.exports = __webpack_public_path__ + "img/result-btn.720d0ebd.png";